import { onUnmounted } from '@vue/composition-api';

export function useCrisisFacilityLockSocket(crisisId, handlers = {}) {
  const channelName = `operational-security-crisis-locks-${crisisId}`;
  let subscribed = false;

  const subscribe = () => {
    if (!window.Echo || subscribed || !crisisId) {
      return;
    }

    subscribed = true;

    window.Echo.private(channelName)
      .listen('.unit-lock.released', (payload) => {
        handlers.onReleased?.(payload);
      })
      .listen('.unit-lock.acquired', (payload) => {
        handlers.onAcquired?.(payload);
      });
  };

  setTimeout(subscribe, 1000);

  onUnmounted(() => {
    if (window.Echo && subscribed) {
      window.Echo.leave(channelName);
    }
  });
}
